import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.795 11.043A6.18 6.18 0 0 0 15 6.175C14.93 2.975 12.367.337 9.173.17A6.16 6.16 0 0 0 2.679 6.18L1.108 9.203q-.01.019-.018.038a1.12 1.12 0 0 0 .528 1.443l.018.008 1.603.734v2.175c0 .618.502 1.12 1.12 1.12h3.36a.56.56 0 0 0 0-1.12H4.36v-2.534a.56.56 0 0 0-.326-.51L2.119 9.68l1.615-3.104A.55.55 0 0 0 3.8 6.32a5.04 5.04 0 0 1 3.92-4.915v1.092a1.68 1.68 0 1 0 1.12 0V1.28q.138-.002.274.007a5.06 5.06 0 0 1 4.476 3.353h-1.39a.56.56 0 0 0-.43.202L9.983 6.985a1.684 1.684 0 1 0 .86.718l1.62-1.943h1.385q.025.219.03.441a5.06 5.06 0 0 1-2.014 4.151.56.56 0 0 0-.22.518l.56 4.48a.56.56 0 0 0 1.112-.14ZM8.28 4.64a.56.56 0 1 1 0-1.12.56.56 0 0 1 0 1.12M9.4 9.12A.56.56 0 1 1 9.4 8a.56.56 0 0 1 0 1.12" }, null, -1)
  ]))]))
}
export default { render: render }